"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniversalSearchCountSchema = void 0;
var zod_1 = require("zod");
/**
 * 통합 SRP 글로벌 필터 CTA 버튼 개수 조회 응답
 * @see {@link https://fe-api-doc.dev.yanolja.in/?api=cx-list-api#tag/universal-search-v1/paths/~1universal-search~1v1~1count/post}
 */
exports.UniversalSearchCountSchema = zod_1.z.object({
    count: zod_1.z.number().nullish(),
    text: zod_1.z.string(),
    enabled: zod_1.z.boolean(),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
});
